import React, { useContext, useEffect, useState } from "react";
import DoctorContext from "../ClinicComponents/ClinicWrapper/DoctorContext";
import "./myPatientsViewAppointments.scss";
import { GET_PATIENT_INFO } from "./MyPatientsViewAppointmentsApiHandler/apiConstants";
import MyPatientsViewHeader from "./MyPatientsViewHeader";
import MyPatientsViewMainContent from "./MyPatientsViewMainContent";
import MyPatientsViewRightContainer from "./MyPatientsViewRightContainer";
import { APPLICABLE_ROLE } from "../DashboardAppointmentsView/Constant";
import { LOCALSTORAGEKEY } from "../../Util/Helper/localStorageUtils";
import { USER_ROLE } from "../../Util/constants";
import { c2cPostApiHandler } from "../../Util/c2cApiHandler";

const MyPatientsViewAppointmnets = () => {
  const patient_account_id = localStorage.getItem(
    "desciptionPropsPatientAcctId"
  );
  const patient_appointment_id = localStorage.getItem(
    "desciptionPropsPatientAppointmentId"
  );

  const [patientInfo, setPatientInfo] = useState({});
  const [upcomingAppointment, setUpcomingAppointment] = useState({});

  const doctor_context = useContext(DoctorContext);
  const [doctorIds, setDoctorIds] = useState([]);
  const clinicId = localStorage.getItem(LOCALSTORAGEKEY.CLINIC_ID);
  const doctorRole = localStorage.getItem(LOCALSTORAGEKEY.DOCTOR_ROLE);
  const user_type = localStorage.getItem("user_type");
  const userId = localStorage.getItem(LOCALSTORAGEKEY.USER_ID);

  // Lifecycle Methods ===>

  useEffect(() => {
    let arr = [];
    if (
      (user_type === APPLICABLE_ROLE.DOCTOR &&
        (doctorRole === USER_ROLE.DOCTOR_ADMIN ||
          doctorRole === USER_ROLE.RESOURCE_ADMIN)) ||
      user_type === APPLICABLE_ROLE.STAFF
    ) {
      doctor_context.selectedDoctor.length > 0 &&
        doctor_context.selectedDoctor.forEach((data) => {
          if (data?.selected === true) {
            arr.push(data.doctor_id);
          }
        });
    } else {
      arr.push(userId);
    }
    setDoctorIds(arr);
  }, [doctor_context.selectedDoctor]);

  useEffect(() => {
    if (doctorIds?.length > 0) {
      getPatientInfo();
    }
  }, [doctorIds]);

  // <===

  // Api Calls ===>

  const getPatientInfo = () => {
    let reqPayload = {
      "authorizer-principal-id": {
        user_id: userId,
        user_type: user_type === APPLICABLE_ROLE.STAFF ? "4" : "1",
      },
      appointment_id: patient_appointment_id,
      patient_account_id: patient_account_id,
      doctor_ids: doctorIds,
      ...(clinicId && { clinic_id: clinicId }),
    };
    const data = c2cPostApiHandler(GET_PATIENT_INFO, reqPayload);
    data.then(([res, error]) => {
      if (!error) {
        if (res?.data?.statusCode === 200) {
          setPatientInfo(res.data);
          setUpcomingAppointment(res?.data?.upcoming_appointment);
        }
      }
    });
  };

  // <===

  // Display UI ===>

  const displayMyPatientsViewLeftContainer = () => {
    return (
      <div className="mypatients-view-left-cont col-sm-9 p-0">
        <MyPatientsViewHeader patientName={patientInfo?.patient_name} />
        {window.innerWidth > 767 && (
          <MyPatientsViewMainContent
            patient_account_id={patient_account_id}
            getPatientInfo={getPatientInfo}
          />
        )}
      </div>
    );
  };

  const displayMyPatientsViewRightContainer = () => {
    return (
      <div
        className="mypatients-view-right-cont col-sm-3"
        style={{ maxHeight: window.innerWidth > 767 ? "100vh" : "" }}
      >
        <MyPatientsViewRightContainer
          patientInfo={patientInfo}
          upcomingAppointment={upcomingAppointment}
          getPatientInfo={getPatientInfo}
          setPatientInfo={setPatientInfo}
        />
      </div>
    );
  };

  // <===

  return (
    <div className="mypatients-view-appointments col-12 px-0">
      <div className="row m-0">
        {displayMyPatientsViewLeftContainer()}
        {displayMyPatientsViewRightContainer()}
        {window.innerWidth < 767 && (
          <MyPatientsViewMainContent
            patient_account_id={patient_account_id}
            getPatientInfo={getPatientInfo}
          />
        )}
      </div>
    </div>
  );
};

export default MyPatientsViewAppointmnets;
